import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from 'mypage/src/constant/queryKey';
import { productCategoryService } from 'shared/src/api';

export const useProductCategoryInitialValues = (
  productCategorySno?: number,
) => {
  return useSuspenseQuery({
    queryKey: queryKey.productCategories(),
    queryFn: () => productCategoryService.getProductCategories(),
    select: data => {
      const fallbackGroup = data.product_category_groups[0];
      const fallback = {
        productCategoryGroup: fallbackGroup,
        productCategory: fallbackGroup.product_categories[0],
      };

      if (!productCategorySno) return fallback;

      const standardCategory = data.product_category_groups.find(v =>
        v.product_categories.some(
          c => c.product_category_sno === productCategorySno,
        ),
      );
      const productCategory = standardCategory?.product_categories.find(
        c => c.product_category_sno === productCategorySno,
      );

      return {
        productCategoryGroup: standardCategory ?? fallbackGroup,
        productCategory: productCategory ?? fallbackGroup.product_categories[0],
      };
    },
  });
};
